var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ModalContent } from '@amzn/atoz-web/Modal';
import { useTranslation } from 'react-i18next';
import { useSelectVtoModalButtons } from './SelectVtoModalButtons';
import { Col } from '@amzn/atoz-web/Col';
import { Text } from '@amzn/atoz-web/Text';
import { DetailedRadio } from '@amzn/atoz-web/DetailedRadio';
import { View } from '@amzn/atoz-web/View';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { useSelectVtoModalContentData } from './utils';
export var SelectVTOModalContent = function (_a) {
    var scheduleShift = _a.scheduleShift, close = _a.close, setModalContent = _a.setModalContent, setModalError = _a.setModalError, vtoOpportunities = _a.vtoOpportunities;
    var t = useTranslation().t;
    var _b = useSelectVtoModalContentData({
        scheduleShift: scheduleShift,
        close: close,
        setModalContent: setModalContent,
        setModalError: setModalError,
        vtoOpportunities: vtoOpportunities
    }), vtoRadioOptionsProps = _b.vtoRadioOptionsProps, acceptVtoIsSubmitting = _b.acceptVtoIsSubmitting, onClickSelect = _b.onClickSelect;
    var buttons = useSelectVtoModalButtons({
        acceptVtoIsSubmitting: acceptVtoIsSubmitting,
        onClickSelect: onClickSelect
    });
    return (React.createElement(ModalContent, { dataTestId: "SelectVTOModalContent", titleText: t('shift_management_features_VtoAcceptModal_title'), buttons: buttons, onCloseButtonClick: close, closeButtonAltText: t('shift_management_common_closeModalButton') },
        React.createElement(View, null,
            React.createElement(StyledText, { dataTestId: "SelectVTOModalContentText" }, t('shift_management_features_VtoAcceptModal_body')),
            React.createElement(Col, { gridGap: "S300", dataTestId: "SelectVTOModalContentOptions" }, vtoRadioOptionsProps.map(function (radioOptions, i) {
                return (React.createElement(DetailedRadio, __assign({}, radioOptions, { key: "VTORadioOption-".concat(i) })));
            })))));
};
var StyledText = styledWithTheme(Text)(function (_a) {
    var theme = _a.theme;
    return "\n    margin: ".concat(theme.selectors.space('S400'), "px 0;\n    ");
});
